import { render } from "./behno-muse-image-grid.vue?vue&type=template&id=265c1a3a&scoped=true"
import script from "./behno-muse-image-grid.vue?vue&type=script&lang=js"
export * from "./behno-muse-image-grid.vue?vue&type=script&lang=js"

import "./behno-muse-image-grid.vue?vue&type=style&index=0&id=265c1a3a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265c1a3a"]])

export default __exports__